export const FETCH_BID_LIST_REQUEST = "FETCH_BID_LIST_REQUEST";
export const FETCH_BID_LIST_SUCCESS = "FETCH_BID_LIST_SUCCESS";
export const FETCH_BID_LIST_FAILURE = "FETCH_BID_LIST_FAILURE";

export const FETCH_BID_DETAILS_REQUEST = "FETCH_BID_DETAILS_REQUEST";
export const FETCH_BID_DETAILS_SUCCESS = "FETCH_BID_DETAILS_SUCCESS";
export const FETCH_BID_DETAILS_FAILURE = "FETCH_BID_DETAILS_FAILURE";
